import { render, staticRenderFns } from "./ModalCandle.vue?vue&type=template&id=6c5e0fdd&scoped=true"
import script from "./ModalCandle.vue?vue&type=script&lang=js"
export * from "./ModalCandle.vue?vue&type=script&lang=js"
import style0 from "./ModalCandle.vue?vue&type=style&index=0&id=6c5e0fdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e0fdd",
  null
  
)

export default component.exports